// @ts-nocheck



import { fetchRequest, initialFetchListParams } from './index';


import { convertDataFromServer as convertDataFromServerIncomeSchedule } from './incomeSchedule';

export const convertDataFromServer = (act) => ({
  ...act,
  incomeSchedule: act.incomeSchedule ?
  convertDataFromServerIncomeSchedule(act.incomeSchedule) :
  null
});

export const addAct = async (act) => {
  const added = await fetchRequest.post('/act', act);
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать акт');
};

export const updateAct = async (act) => {
  const updated = await fetchRequest.put('/act', act);
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить акт');
};

export const fetchActs = async (
params = initialFetchListParams) =>
{
  const acts = await fetchRequest.get('/act', {
    ...initialFetchListParams,
    ...params
  });
  if (acts) {
    return {
      ...acts,
      data: acts.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список актов');
};

export const getAct = async (id, params = {}) => {
  const act = await fetchRequest.get(`/act/${id}`, params);
  if (act) return convertDataFromServer(act);
  throw new Error('Не удалось загрузить акт');
};

export const deleteAct = async (id) => {
  const deleted = await fetchRequest.delete(`/act/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить акт');
};

export const changeStatus = async (
id,
status) =>
{
  const act = await fetchRequest.put(`/act/changeStatus`, { id, status });
  if (act) return convertDataFromServer(act);
  throw new Error('Не удалось изменит статус акта');
};

export default {
  changeStatus,
  addAct,
  updateAct,
  fetchActs,
  deleteAct,
  getAct
};
